import { css } from "@emotion/css";

const styles = {
  badge: css`
    width: 1.2rem;
    height: 1.2rem !important;

    border-radius: 50% !important;

    z-index: 0 !important;
  `,
};

export default styles;
